import { db } from '../FirebaseLibrary';

export const createGamePlayersReference = (gameId: string) => {
    return db.collection(`games/${gameId}/game-players`);
};

export const createGamePlayersCollectionGroupReference = () => {
    return db.collectionGroup('game-players');
};

export const createGamePlayerReference = (gameId: string, playerId: string) => {
    return createGamePlayersReference(gameId).doc(playerId);
};

export const fetchGamePlayerFirestoreAPI = (gameId: string, playerId: string) => {
    return createGamePlayerReference(gameId, playerId).get();
};

export const fetchGamePlayersOfSingleGameFirestoreAPI = (gameId: string) => {
    return createGamePlayersReference(gameId).get();
};

export const fetchGamePlayersFirestoreAPI = (teamId: string, playerId: string) => {
    return createGamePlayersCollectionGroupReference().where('id', '==', playerId).where('teamId', '==', teamId).where('timeOfGame', '<=', new Date())
        .orderBy('timeOfGame', 'desc')
        .get();
};
